import type { OptionLeg } from "@/types/options";

/** Shorthand constructor for an OptionLeg. */
export function leg(
  strike: number,
  type: "call" | "put",
  side: "long" | "short",
  quantity: number = 1,
): OptionLeg {
  return { strike, type, side, quantity };
}
